<script>
  import Options from './Options.svelte'
  import Chart from './Chart.svelte'
  import { select } from 'd3-selection'

  export let allData
  export let isMobile
  export let selectedIndicator

  let selectedFilter = []
  let selectedCountry = ''
  let activeDropdown = false

  // $: getFilters = () => {
  //   let filteredData = countries.filter((a) => a.country !== selectedCountry)
  //   if (activeCircle && activeCircle.name) {
  //     filteredData.push(activeCircle)
  //   } else {
  //     filteredData = [...countries]
  //   }
  //   return selectedFilter.length === 0
  //     ? filteredData
  //     : countries.filter((a) => selectedFilter.some((b) => a[b]))
  // }

  $: filteredData = () => {
    return selectedFilter.length === 0
      ? allData
      : allData.filter((country) =>
          selectedFilter.some((filterType) => country[filterType])
        )
  }

  document.addEventListener('click', (e) => {
    const dropdown = document.getElementsByClassName('input__select')[0]
    const clickedCircle = select(e.target).classed('circle')

    if (dropdown.contains(e.target) || clickedCircle) {
      return
    }
    selectedCountry = ''
  })
</script>

<template>
  <Options
    allData="{allData}"
    filteredData="{filteredData()}"
    bind:selectedIndicator
    bind:selectedFilter
    bind:selectedCountry
    bind:activeDropdown
  />

  <Chart
    allData="{allData}"
    filteredData="{filteredData()}"
    selectedIndicator="{selectedIndicator}"
    bind:selectedFilter
    bind:selectedCountry
    bind:activeDropdown
    isMobile="{isMobile}"
  />
</template>
